import { forwardRef, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { selectIcon, selectStyle } from './Select.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { atoms } from '@ui-lib/css';
import { FieldMessage } from '../FieldMessage/FieldMessage';
import { Box, Stack } from '@ui-lib';

type Size = 'small' | 'medium' | 'large';
type Tone = 'neutral' | 'critical';

interface Props {
  id?: string;
  children: ReactNode;
  size?: Size;
  fullWidth?: boolean;
  message?: string;
  tone?: Tone;
}

type SelectProps = Props & UseFormRegisterReturn;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ children, size = 'medium', fullWidth = false, id, tone, message, ...rest }, ref) => (
    <Stack gap="xsmall">
      <div style={{ position: 'relative', display: 'flex', flexGrow: fullWidth ? 1 : undefined }}>
        <select {...rest} className={selectStyle({ size, tone })} ref={ref}>
          {children}
        </select>
        <FontAwesomeIcon className={selectIcon} icon={faAngleDown} />
      </div>
      {message && <FieldMessage id={id} tone={tone} message={message} />}
    </Stack>
  )
);

Select.displayName = 'Select';
